import { SvrSubmission } from "../../../services/domain/SvrSubmission";
import { fieldLabels } from "../fieldLabels";


export type SubmissionActivityFeedProps = {
  submission: SvrSubmission | null;
};

export type FieldChange = {
  field: keyof typeof fieldLabels;
  oldValue: string | null;
  newValue: string | null;
};

export type ChangeActivityBody = {
  changes: FieldChange[];
};

export enum ActivityType {
  SvrSubmissionCreated = 18,
  SvrSubmissionUpdated = 19,
  SvrSubmissionDeactivated = 20,
}
